export default __webpack_public_path__ + "static/media/acknowledgements_img3.28399213.png";